function ProblemSolution({ problem, solution }) {
  return (
    <section className="service-section service-problem-section">
      <div className="container service-problem-grid">
        <div className="service-problem-card">
          <span>Problem</span>
          <h2>What this business solves</h2>
          <p>{problem}</p>
        </div>
        <div className="service-problem-card service-problem-card--solution">
          <span>Solution</span>
          <h2>How the project creates value</h2>
          <p>{solution}</p>
        </div>
      </div>
    </section>
  );
}

export default ProblemSolution;
